import React, { useEffect, useState } from 'react';
import { calculateEventPositions, WCS } from '../../week-utils';
import { IMarkDate } from '../../../calendars';
import DayHeader from '../day-header';
import { WeekDaySC } from './week-day.styled';
import { isWeekend } from 'date-fns';

interface WeekDayProps {
  date: string;
  markedEvents?: IMarkDate[];
  minHour: number;
  onClick: (e: any, rect: any, date: any) => void;
  isLastDay: boolean;
  isFirstDay: boolean;
}

const WeekDay: React.FunctionComponent<WeekDayProps> = ({
  date,
  markedEvents,
  minHour,
  onClick,
  isFirstDay,
  isLastDay,
}) => {
  const calculatedMarkers = React.useMemo(() => {
    return calculateEventPositions(minHour, markedEvents, WCS.gridPadding).map(
      ({ event, position }, index) => {
        return (
          <div
            aria-hidden="true"
            style={{
              background: event.color,
              position: 'absolute',
              top: position.top,
              height: position.height,
              width: `${position.width * 95}%`,
              left: `${position.left * 95}%`,
              zIndex: position.zIndex,
              borderRadius: 4,
            }}
            key={`${event.start}-${event.end}-${index}`}
          />
        );
      },
    );
  }, [minHour, markedEvents]);

  const weekend = isWeekend(new Date(date));

  const divRef = React.useRef<HTMLDivElement | null>(null);
  const [rect, setRect] = useState<null | DOMRect>(null);

  const [dayHeaderRect, setDayHeaderRect] = useState<null | DOMRect>(null);

  useEffect(() => {
    if (divRef.current) {
      setRect(divRef.current.getBoundingClientRect());
    }
  }, [divRef.current]);

  return (
    <>
      <WeekDaySC
        style={{ background: weekend ? 'rgba(251, 251, 251, 0.8)' : 'transparent' }}
        onClick={(e) => {
          const elemY = dayHeaderRect ? dayHeaderRect.y : 0;
          const isGridClicked =
            elemY + WCS.dayHeaderHeight - document.documentElement.scrollTop < e.clientY;
          if (isGridClicked) {
            onClick(e, rect, date);
          } else {
            e.stopPropagation();
          }
        }}
        ref={divRef}
      >
        <DayHeader
          date={date}
          isFirstDay={isFirstDay}
          isLastDay={isLastDay}
          setRect={setDayHeaderRect}
        />
        <div className="container">
          <div className="mark-container">{calculatedMarkers}</div>
        </div>
      </WeekDaySC>
    </>
  );
};

export default React.memo<WeekDayProps>(WeekDay);
